import Notification, { NotificationState } from "../model/Notification";
import API, { responseOf } from "./base";

export const getNotification = (
  notificationId: string,
): Promise<Notification> =>
  responseOf(
    API.get(`/notifications/${notificationId}`, {
      public: true,
    }),
  );

export const getNotificationsByUser = (
  userId: string,
  limit: number = 20,
): Promise<Notification[]> =>
  responseOf(
    API.get(`/notifications/byUser/${userId}`, {
      public: true,
      params: { limit },
    }),
  );

export const getNotificationsByUserAndOrganization = (
  userId: string,
  organizationId: string,
  limit: number = 20,
): Promise<NotificationState> =>
  responseOf(
    API.get(
      `/notifications/byUser/${userId}/byOrganization/${organizationId}`,
      {
        public: true,
        params: { limit },
      },
    ),
  );

export const markAllNotificationsStatus = async (
  userId: string,
  status: string,
  organizationId: string,
): Promise<void> => {
  await API.post(`/notifications/markStatusAll/${userId}/${organizationId}`, {
    status,
  });
};

export const markNotificationStatus = async (
  notificationId: string,
  status: string,
): Promise<void> => {
  await API.post(`/notifications/${notificationId}/markStatus`, {
    status,
  });
};
